import React from "react";
import { Controller, Control, FieldErrors } from "react-hook-form";
import Flatpickr from "react-flatpickr";
import { FormFeedback, Label } from "reactstrap";
import { parseLocalDate } from "helpers/constant";

/* ---------- Types ---------- */

interface CommonFlatpickrProps {
  control: Control<any>;
  name: string;
  label?: string;
  placeholder?: string;
  rules?: Record<string, any>;
  errors?: FieldErrors<any>;
  options?: Record<string, any>;
  className?: string;
  description?: string; // ✅ ADD THIS
  disableFuture?: boolean;
  disabled?: boolean;
  position?: boolean;
  showerror?: any;
}

/**
 * Common reusable Flatpickr for react-hook-form + Reactstrap
 */
const CommonFlatpickr: React.FC<CommonFlatpickrProps> = ({
  control,
  name,
  label,
  placeholder = "Select date",
  rules = {},
  errors = {},
  options = {},
  className = "",
  description,
  disabled = false,
}) => {
  const isRequired =
    typeof rules?.required === "string" || rules?.required === true;

     const dateInputStyle = {
    height: "28px",
    fontSize: "13px",
    padding: "10px 14px",
  } as React.CSSProperties;

  return (
    <div>
      {label && (
        <Label className="form-label" style={{ marginBottom: "5px" }}>
          {label}
          {isRequired && (
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          )}
          {description && (
            <small className="text-muted d-block">{description}</small>
          )}
        </Label>
      )}

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <>
            <Flatpickr
              id={name}
              className={`form-control form-control-lg ${className} ${errors?.[name] ? "is-invalid" : ""
                }`}
              style={dateInputStyle}
              placeholder={placeholder}
              disabled={disabled}
              value={
                field.value
                  ? (parseLocalDate(field.value) ?? "")
                  : ""
              }
              onChange={(dates: Date[]) => {
                if (dates[0]) {
                  const d = dates[0];
                  const year = d.getFullYear();
                  const month = String(d.getMonth() + 1).padStart(2, "0");
                  const day = String(d.getDate()).padStart(2, "0");
                  const formatted = `${year}-${month}-${day}`; // ✅ local date
                  field.onChange(formatted);
                } else {
                  field.onChange("");
                }
              }}
              options={{
                dateFormat: "d-m-Y",
                allowInput: false,
                clickOpens: !disabled,
                ...options,
              }}
            />
            {errors?.[name] && (
              <FormFeedback className="d-block position-absolute">
                {(errors[name] as any)?.message}
              </FormFeedback>
            )}
          </>
        )}
      />
    </div>
  );
};

export default CommonFlatpickr;
